import { Input } from 'src/@/components/ui/input';
import { Label } from 'src/@/components/ui/label';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';

export default function PerfilAlterarSenha({
  isSubmitting,
  password,
  repeatPassword,
  changePassword,
  changeRepeatPassword,
  submit
}) {
  return (
    <div className="max-w-2xl">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 space-y-2">
          <Label className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Senha</Label>
          <Input
            value={password}
            type="password"
            onChange={changePassword}
            className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg"
          />
        </div>
        <div className="flex-1 space-y-2">
          <Label className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider">Confirmar Senha</Label>
          <Input
            value={repeatPassword}
            type="password"
            onChange={changeRepeatPassword}
            className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg"
          />
        </div>
      </div>
      <div className="mt-6">
        <ButtonLoading
          onClick={submit}
          loading={isSubmitting}
          className="h-9 gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-xs font-semibold rounded-lg shadow-lg shadow-violet-500/20 transition-all hover:scale-105 active:scale-95"
        >
          Salvar
        </ButtonLoading>
      </div>
    </div>
  );
}
